import request from '@/utils/request'

export function getAllCertificates(query){
    return request({
      url: '/Certificate/GetAll',
      method: 'Get',
      params: query
    })
  }